import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, finalize } from "rxjs";
import { environment } from "src/environments/environment";
import { SpinnerService } from "../services/spinner.service";

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {
    constructor(private __spinnerService: SpinnerService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let requestToken = req;
        this.__spinnerService.show();
        
        //Agrega header azure microservices
        requestToken = req.clone({
            setHeaders: {
            }
        })
        return next.handle(requestToken).pipe(
            finalize(() => this.__spinnerService.hide()));
    }
}
